import type { GriffelStyle } from '@fluentui/react-components'

/** Horizontal scroll for preformatted blocks that exceed the bubble width. */
export const codeStyles: GriffelStyle = {
  '& pre': {
    overflowX: 'auto',
    whiteSpace: 'pre',
  },
}
